import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const UserOptionsTemplate = htmlE`
  <style>
    .user-options-dialog .user-modal-input-grid {
      display: grid;
      grid-template-columns: 150px auto;
      gap: 0.5rem;
    }

    .user-options-dialog input {
      max-width: 200px;
    }

    .user-options-dialog .generate-password-section {
      border-top: 1px solid var(--border-color);
      gap: 0.5rem;
    }
  </style>

  <div class="user-options-modal">
    <div class="tabs-container" id="userOptionsTab">
      <div class="tabs is-boxed">
        <ul>
        ${({
          canHideUserOptionHideDotItems,
          canHideUserOptionHideCheckBoxColumn,
          canHideUserOptionHideFilterSection,
          canHideUserOptionAutoStartUpload,
          showUserOptionLocalTimeZone,
          showOnlyTwoFactorAuthTab,
        }) => {
          if (
            (!canHideUserOptionHideDotItems ||
              !canHideUserOptionHideCheckBoxColumn ||
              !canHideUserOptionHideFilterSection ||
              !canHideUserOptionAutoStartUpload ||
              showUserOptionLocalTimeZone) &&
            !showOnlyTwoFactorAuthTab
          )
            return `<li id="userOptionsTab1" rel="tab1">
              <a>
                <span class="icon is-small">
                  <i class="icon-cog"></i>
                </span>
                <span data-i18n-key="preferences">preferences</span>
              </a>
            </li>`;
          return ``;
        }}
        ${({
          canHideUserOptionChangePassword,
          hasChangePasswordPermission,
          showOnlyTwoFactorAuthTab,
        }) => {
          if (
            !canHideUserOptionChangePassword &&
            hasChangePasswordPermission &&
            !showOnlyTwoFactorAuthTab
          ) {
            return `<li id="userOptionsTab2" rel="tab2">
          <a>
            <span class="icon is-small"><i class="icon-key"></i></span>
            <span data-i18n-key="changeYourPassword"
              >changeYourPassword</span
            >
          </a>
        </li>`;
          }
          return ``;
        }}
        ${({ enableUserOption2fa, showOnlyTwoFactorAuthTab }) => {
          if (enableUserOption2fa || showOnlyTwoFactorAuthTab) {
            return `<li id="userOptionsTab4" rel="tab4">
              <a>
                <span class="icon is-small"><i class="icon-lock"></i></span>
                <span data-i18n-key="setup2FactorAuth">setup2FactorAuth</span>
              </a>
            </li>`;
          }

          return ``;
        }}

        ${({ canHideUserOptionChangePhone, showOnlyTwoFactorAuthTab }) => {
          if (!canHideUserOptionChangePhone && !showOnlyTwoFactorAuthTab) {
            return `<li id="userOptionsTab3" rel="tab3">
            <a>
            <span class="icon is-small"><i class="icon-phone"></i></span>
            <span data-i18n-key="phoneNo">phoneNo</span>
            </a>
            </li>`;
          }
          return ``;
        }}

        </ul>
      </div>
      <div class="content-tab">
        ${(params) => {
          const {
            canHideUserOptionHideDotItems,
            canHideUserOptionHideCheckBoxColumn,
            canHideUserOptionHideFilterSection,
            canHideUserOptionAutoStartUpload,
            showUserOptionLocalTimeZone,
            showOnlyTwoFactorAuthTab,
          } = params;
          if (
            (!canHideUserOptionHideDotItems ||
              !canHideUserOptionHideCheckBoxColumn ||
              !canHideUserOptionHideFilterSection ||
              !canHideUserOptionAutoStartUpload ||
              showUserOptionLocalTimeZone) &&
            !showOnlyTwoFactorAuthTab
          ) {
            return `<div id="preference" class="tab-pane" name="tab1">
              <form id="userOptionsPreferenceForm">
                ${
                  !canHideUserOptionHideDotItems
                    ? `<div class="is-flex is-align-items-center mt-2">
                  <input
                    id="hideDotItems"
                    type="checkbox"
                    name="hideDotItems"
                  />
                  <label
                    for="hideDotItems"
                    class="text-sm text-primaryMain ml-2"
                    data-i18n-key="hideDotItems"
                  >
                  hideDotItems
                  </label>
                </div>`
                    : ``
                }

                ${
                  !canHideUserOptionHideCheckBoxColumn
                    ? `<div class="is-flex is-align-items-center mt-2">
                    <input
                      id="hideCheckboxColumn"
                      type="checkbox"
                      name="hideCheckboxColumn"
                    />
                    <label
                      for="hideCheckboxColumn"
                      class="text-sm text-primaryMain ml-2"
                      data-i18n-key="hideCheckboxColumn"
                    >
                    hideCheckboxColumn
                    </label>
                  </div>`
                    : ``
                }

                ${
                  !canHideUserOptionHideFilterSection
                    ? `<div
                    id="hideFilterSectionWrapper"
                    class="is-flex is-align-items-center mt-2"
                  >
                    <input
                      id="hideFilterSection"
                      type="checkbox"
                      name="hideFilterSection"
                    />
                    <label
                      for="hideFilterSection"
                      class="text-sm text-primaryMain ml-2"
                      data-i18n-key="hideFilterSection"
                    >
                    hideFilterSection
                    </label>
                  </div>`
                    : ``
                }

                ${
                  !canHideUserOptionAutoStartUpload
                    ? `<div class="is-flex is-align-items-center mt-2">
                  <input
                    id="autoStartUpload"
                    type="checkbox"
                    name="autoStartUpload"
                  />
                  <label
                    for="autoStartUpload"
                    class="text-sm text-primaryMain ml-2"
                    data-i18n-key="whenChoosingFileToUploadAutoStartUpload"
                  >
                  whenChoosingFileToUploadAutoStartUpload
                  </label>
                </div>`
                    : ``
                }

                ${
                  showUserOptionLocalTimeZone
                    ? `<div class="is-flex is-align-items-center mt-2">
                  <input
                    id="showLocalTimeZone"
                    type="checkbox"
                    name="showLocalTimeZone"
                    checked
                  />
                  <label
                    for="showLocalTimeZone"
                    class="text-sm text-primaryMain ml-2"
                    data-i18n-key="showDatesInLocalTimeZone"
                  >
                  showDatesInLocalTimeZone
                  </label>
                </div>`
                    : ``
                }
              </form>
            </div>`;
          }
          return ``;
        }}
        ${({
          canHideUserOptionChangePassword,
          hasChangePasswordPermission,
          canHideUserOptionGeneratePassword,
          showOnlyTwoFactorAuthTab,
        }) => {
          if (
            !canHideUserOptionChangePassword &&
            hasChangePasswordPermission &&
            !showOnlyTwoFactorAuthTab
          ) {
            return `<div id="changePassword" class="tab-pane" name="tab2">
            <form id="userOptionsChangePasswordForm">
              <div class="mt-3 user-modal-input-grid">
                <label for="currentPassword">
                  <span data-i18n-key="currentPassword"
                    >currentPassword</span
                  >
                  <span>:</span>
                </label>
                <div>
                  <input
                    id="currentPassword"
                    autocomplete="off"
                    data-validate="required"
                    data-mark-error="true"
                    name="current_password"
                    data-inline-error="true"
                    type="password"
                    class="input modal-input"
                  />
                </div>
              </div>

              <div class="mt-3 user-modal-input-grid">
                <label for="newPassword">
                  <span data-i18n-key="newPassword"
                    >newPassword</span
                  >
                  <span>:</span>
                </label>
                <div>
                  <input
                    id="newPassword"
                    autocomplete="off"
                    data-validate-minlength="6"
                    data-min-length="6"
                    data-validate="required,min-length"
                    data-mark-error="true"
                    name="new_password1"
                    data-inline-error="true"
                    type="password"
                    class="input modal-input"
                  />
                </div>
              </div>

              <div class="mt-3 user-modal-input-grid">
                <label for="confirmPassword">
                  <span data-i18n-key="confirmPassword"
                    >confirmPassword</span
                  >
                  <span>:</span>
                </label>
                <div>
                  <input
                    id="confirmPassword"
                    autocomplete="off"
                    data-validate="required,match"
                    data-match="new_password1"
                    data-mark-error="true"
                    name="new_password2"
                    data-inline-error="true"
                    type="password"
                    class="input modal-input is-ellipsis"
                  />
                </div>
              </div>
            </form>
            ${
              !canHideUserOptionGeneratePassword
                ? `<div
              id="userOptionsGeneratePassword"
              class="is-flex is-align-items-center generate-password-section is-hidden pt-2 mt-3 is-justify-content-flex-end"
            >
              <input
                id="generatedPassword"
                name="generatedPassword"
                class="input modal-input"
              />
              <button type="button" class="use-this primary-button is-bg-none">
                <span data-i18n-key="useThis">useThis</span>
              </button>
              <button
                type="button"
                class="cancel-generate-password primary-button is-bg-none"
              >
                <span data-i18n-key="cancel">cancel</span>
              </button>
            </div>`
                : ``
            }

          </div>`;
          }
          return ``;
        }}
        ${({ canHideUserOptionChangePhone, showOnlyTwoFactorAuthTab }) => {
          if (!canHideUserOptionChangePhone && !showOnlyTwoFactorAuthTab) {
            return `<div id="phoneNumber" class="tab-pane" name="tab3">
          <form id="userOptionsPhoneNumberForm">
            <div class="mt-2 user-modal-input-grid">
              <label for="phoneNo">
                <span data-i18n-key="phoneNo"
                  >phoneNo
                </span>
                <span>:</span>
              </label>
              <div>
                <input
                  data-validate="required,phone"
                  data-mark-error="true"
                  data-inline-error="true"
                  id="phoneNo"
                  name="phone"
                  class="input modal-input"
                />
              </div>
            </div>
          </form>
        </div>`;
          }
          return ``;
        }}
        ${({ enableUserOption2fa, showOnlyTwoFactorAuthTab }) => {
          if (enableUserOption2fa || showOnlyTwoFactorAuthTab) {
            return `
              <div id="setup2FactorAuth" class="tab-pane" name="tab4">

              </div>`;
          }
          return ``;
        }}
      </div>
    </div>
  </div>
`;

export default UserOptionsTemplate;
